import React from 'react';

export default ({ title, details, stackTrace }) => {
  return (
    <div className="alert alert-danger" role="alert">
      <p><strong>Oh snap!</strong> {title}</p>
      <details style={{ whiteSpace: 'pre-wrap' }}>
        <p>{details}</p>
        {stackTrace ? (
          <div>
            <br />
            <p>{stackTrace}</p>
          </div>
        ) : null
        }
      </details>
    </div >
  )
}


// WEBPACK FOOTER //
// ./src/components/Alert.js